import script from "./Accident.vue?vue&type=script&setup=true&lang=js"
export * from "./Accident.vue?vue&type=script&setup=true&lang=js"

import "./Accident.vue?vue&type=style&index=0&id=6a68bd52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a68bd52"]])

export default __exports__